class LpTabNav extends HTMLElement {
  constructor() {
    super();
    
    this.activeTab = 1;
    this.tabLinkElements = this.querySelectorAll('[data-role="tab-link"]');
    this.tabContentElements = this.querySelectorAll('[data-role="tab-content"]');
    
    this.tabLinkElements.forEach((el) => {
      el.addEventListener("click", (e) => {
        // console.log("clicked", e.currentTarget.getAttribute("data-tab"));
        const tab = Number(e.currentTarget.getAttribute("data-tab"));
        if(tab == this.activeTab) return
        this.activeTab = tab;
        this.showTabContent(tab);
      });
    });
  }

  showTabContent(tab) {
    // console.log("showTab", tab, this.tabContentElements);
    this.tabContentElements.forEach( el => {
      const tab = Number(el.getAttribute("data-tab"));
      
      if(tab == this.activeTab) {
        el.classList.remove('hidden');
        return
      }
      
      el.classList.add('hidden');
      
    })
  }
  
}

customElements.define("lp-tab-nav", LpTabNav);
